import Vue from 'vue'
// import TDesign from 'tdesign-vue';
// import 'tdesign-vue/es/style/index.css';
// import '@surely-vue/table/dist/index.less'
import Antd from 'ant-design-vue';
import App from './App.vue';
import router from './router/index.js';
import "./css/tailwindcss.css";
import Vika from './js/vikaRecord.js';
import _ from 'lodash';
import 'ant-design-vue/dist/antd.css';
//VXETable
import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/es/style.css'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import XEUtils from 'xe-utils'
import axios from 'axios'
import 'remixicon/fonts/remixicon.css'

// 配置 axios 默认值
axios.defaults.baseURL = 'https://o4kvrlopiu.bja.sealos.run/'; // 设置 API 的基础路径
axios.defaults.timeout = 60000; // 设置请求超时时间

// import STable from '@surely-vue/table';
// import '@surely-vue/table/dist/index.css'
//online view office pdf image


//格式化单元格内容
VXETable.formats.add('formatterNum', ({ cellValue }, digits = 2) => {
  return XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
})
VXETable.formats.add('formatTime', ({ cellValue }) => {
  return XEUtils.toDateString(cellValue, 'yyyy-MM-dd')
})


Vue.config.productionTip = false
// Vue.use(TDesign);
Vue.use(Antd);
Vue.prototype.$vika = Vika;
Vue.prototype._ = _
Vue.use(VXETable).use(VxeUIAll)
Vue.prototype.$axios = axios;
// Vue.use(STable)


new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
